import { IFormErrors } from '@interfaces/IFormsErrors';
import { IPeriod, IPeriodWithHolidays } from '@interfaces/IPeriod';
import { Action } from '@ngrx/store';

export enum EPeriodsViewActions {
  GetPeriodRequest = '[Periods] Get Period Request',
  GetPeriodSuccess = '[Periods] Get Period Success',
  GetPeriodFailure = '[Periods] Get Period Failure',
  ClearGetPeriod = '[Periods] Clear Get Period',

  GetGroupPeriodsRequest = '[Periods] Get Group Periods Request',
  GetGroupPeriodsSuccess = '[Periods] Get Group Periods Success',
  GetGroupPeriodsFailure = '[Periods] Get Group Periods Failure',
  ClearGroupPeriods = '[Periods] Clear Group Periods',
}

export class GetPeriodRequest implements Action {
  public readonly type = EPeriodsViewActions.GetPeriodRequest;

  constructor(public periodId: number) {}
}

export class GetPeriodSuccess implements Action {
  public readonly type = EPeriodsViewActions.GetPeriodSuccess;

  constructor(public period: IPeriod) {}
}

export class GetPeriodFailure implements Action {
  public readonly type = EPeriodsViewActions.GetPeriodFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetPeriod implements Action {
  public readonly type = EPeriodsViewActions.ClearGetPeriod;
}

export class GetGroupPeriodsRequest implements Action {
  public readonly type = EPeriodsViewActions.GetGroupPeriodsRequest;

  constructor(public groupId: number) {}
}

export class GetGroupPeriodsSuccess implements Action {
  public readonly type = EPeriodsViewActions.GetGroupPeriodsSuccess;

  constructor(public periods: IPeriodWithHolidays[]) {}
}

export class GetGroupPeriodsFailure implements Action {
  public readonly type = EPeriodsViewActions.GetGroupPeriodsFailure;

  constructor(public error: IFormErrors) {}
}

export class ClearGroupPeriods implements Action {
  public readonly type = EPeriodsViewActions.ClearGroupPeriods;
}

export type PeriodsViewActions =
  | GetPeriodRequest
  | GetPeriodSuccess
  | GetPeriodFailure
  | ClearGetPeriod
  | GetGroupPeriodsRequest
  | GetGroupPeriodsSuccess
  | GetGroupPeriodsFailure
  | ClearGroupPeriods;
